import React, { useState, useEffect } from 'react';
import { QueryClient, QueryClientProvider, useQuery, useQueryClient } from 'react-query';
import { useCartContents } from '@src/hooks';
import { ReactDrawer } from '@parts';
import pluralize from 'pluralize';

import CartButton from './CartButton';
import CartList from './CartList';
import CartNavigation from './CartNavigation';
import CartTotals from './CartTotals';
import ShareCartLink from './ShareCartLink';
import CartUrgencyNotice from './CartUrgencyNotice';
import FinancingOptions from './FinancingOptions';

const queryClient = new QueryClient();

const MiniCartProvider = (props) => {
  return (
    <QueryClientProvider client={queryClient}>
      <MiniCart {...props}></MiniCart>
    </QueryClientProvider>
  );
};

const MiniCart = (props) => {
  const [open, setOpen] = useState(false);
  const { status, data: cartContents, error, isLoading, refetch } = useCartContents();
  const queryClient = useQueryClient();
  const ctx = window.app;

  // Update cart and open when adding to cart
  useEffect(() => {
    ctx.on('cart.update', (state) => {
      queryClient.invalidateQueries('cart');
      window.scrollTo(0, 0);
      refetch();
      if (window.location.pathname !== '/cart') {
        setOpen(true);
      }
    });

    document.documentElement.addEventListener('wetheme-cart-update', () => {
      queryClient.invalidateQueries('cart');
      refetch();
      if (window.location.pathname !== '/cart') {
        setOpen(true);
      }
    });
  }, []);

  useEffect(() => {
    // console.log('Cart contents', cartContents);
    if (cartContents) {
      ctx.hydrate({ systemCart: cartContents, cartContents: { items: cartContents.items, item_count: cartContents.item_count } });
    }
  }, [cartContents]);

  if (isLoading) {
    return null;
  }

  const { items, item_count } = cartContents;

  return (
    <>
      <CartButton {...props} handleClick={setOpen} open={open} itemCount={item_count}></CartButton>
      <ReactDrawer className="minicart" id="miniCartDrawer" showDrawer={open} setShowDrawer={setOpen} position={'right'}>
        <div className="drawer-scroller">
          <header className="Drawer__header">
            <div>
              <h3>
                Bag{' '}
                <small>
                  ({item_count} {pluralize('item', item_count)})
                </small>
              </h3>
            </div>
            <button type="button" onClick={() => setOpen(!open)} aria-label="Close">
              <svg viewBox="0 0 20 20" className="icon" width="1em" height="1em">
                <use href="#close"></use>
              </svg>
            </button>
          </header>
          <div className="Drawer__contents">
            <ShareCartLink data={cartContents} />
            <CartUrgencyNotice data={cartContents} />
            <CartList data={cartContents} setShowDrawer={setOpen} />
            <CartTotals data={cartContents} />
            <FinancingOptions />
            <CartNavigation data={cartContents} setShowDrawer={setOpen} showBackButton={true}></CartNavigation>
          </div>
        </div>
      </ReactDrawer>
    </>
  );
};

export default MiniCartProvider;
